<template>
    <div @mousedown="onMouseDown" @mousemove="onMouseMove" @click="go_to($event)" class="card carousel-card" @mouseover="hover = true" @mouseleave="hover = false" :class="{ 'hover-card': hover, 'regular-card': !hover }" :style="{ backgroundImage: `url(${chat_template.background_image})` }">
        <div class="card-body">
            <h5 class="card-title">{{ t(`chat-template.title.${chat_template.id}`) }}</h5>
        </div>
    </div>
      <!-- Chat Modal -->
    <ion-modal
      ref="chatModal"
      :is-open="showChatModal"
      @didDismiss="handleModalDismiss"
    >
      <ion-header>
        <ion-toolbar>
          <ion-buttons slot="start">
            <ion-button @click="handleModalDismiss()"><i class="bi bi-x action-icon"></i></ion-button>
          </ion-buttons>
          <ion-title ><i class="bi bi-chat-dots-fill"></i>{{ t(`chat-template.title.${selectedTemplate.id}`)}}</ion-title>
        </ion-toolbar>
      </ion-header>
      <ion-content class="ion-padding">
        <MiniChat :templateID="selectedTemplate.id" @close="showChatModal = false" />
      </ion-content>
    </ion-modal>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { defineProps } from 'vue'
import { fetchWrapper } from '@/helpers/fetch-wrapper'

import { useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n'
import { IonModal, IonHeader, IonToolbar, IonButtons, IonButton, IonTitle, IonContent } from '@ionic/vue'
import MiniChat from '@/components/MiniChat.vue'
const { t } = useI18n()
const selectedTemplate = ref(false)
const showChatModal = ref(false)
const handleModalDismiss = () => {
  showChatModal.value = false
  selectedTemplate.value = false
}
const isDragging = ref(false)

const onMouseDown = () => {
  console.log('mousedown set dragging false')
  isDragging.value = false
}
const onMouseMove = () => {
  console.log('mousemove set dragging true')
  isDragging.value = true
}

onMounted(async () => {
  showChatModal.value = false
  selectedTemplate.value = false
})

const router = useRouter()

const props = defineProps({
  chat_template: {
    type: Object,
    required: true
  }
})

async function go_to(event) {
  if (isDragging.value) {
    event.preventDefault()
    event.stopPropagation()
    return
  }
  let chat_template = props.chat_template
  await go_to_setup(chat_template)
}
  async function go_to_setup(template) {
    var templateID = template.id
    const response = await fetchWrapper.post(`/chat/template/`, {templateID: templateID})
    selectedTemplate.value = template
    showChatModal.value = true
  }

const hover = ref(false)
</script>
<style lang="css" scoped>

h1,
h2 {
  font-weight: normal;
}
.progress-bar {
    background: #aaf;
}
.carousel__slide {
  padding-right: 20px;
  padding-top: 10px;
  padding-bottom: 10px;
}
.progress,.progress + small{
  z-index: 9;
  left:10px;
}
.carousel-card {
  height: 115px;
  width: 200px;
  background-size: cover;
  background-position: center;
}
.carousel-card::before {
    content: '';
    position: absolute;
    inset: 0;
    background: rgba(0, 0, 0, 0.5);
    z-index: 1;
    transition: .5s ease;
}
.carousel-card:hover::before {
    background: rgba(0, 0, 0, 0);
    transition: .5s ease;
}
.carousel-card .card-body {
  height: 100%;
  width: 100%;
  background-size: cover;
  background-position: center;
  position: relative;
}
h5.card-title {
  font-size: 16px;
  color: #ffffff !important;
  padding: 5px;
  text-shadow: 0px 0px 5px rgba(0, 0, 0, 1);
  width: 100%;
  text-align: center;
  -webkit-text-stroke: 3px black;
  paint-order: stroke fill;
  position: relative;
  z-index: 2;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}

.hover-card {
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  background-color: #ddf;
}
.regular-card {
  background-color: #f8f8ff;
}
</style>
